import { FC } from "react";
import { t } from "../i18n/ar";

// SKU label that opens the jumia.ma product page when the backend knows it
// (Product.url). Without a URL it is the same plain label as before, so the
// worker can still match it against the shelf tag.
export const SkuLink: FC<{ sku: string; url?: string | null; className?: string }> = ({ sku, url, className = "" }) => {
    if (!url) return <span className={className}>{sku}</span>;
    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title={t.productPage}
            onClick={(e) => e.stopPropagation()}
            className={`${className} cursor-pointer text-[#c2410c] underline decoration-[#f68b1e] decoration-4 underline-offset-4 hover:bg-orange-50`}
        >
            {sku} <span className="align-middle text-[0.6em] no-underline" aria-hidden>🔗</span>
        </a>
    );
};
